// 用户中心模块

import axios from './request'
//定义跨域代理路由
const currentUrl = window.location.href;
const regex = /www\./;
const mobil = /mobil\./
const phone =mobil.test(currentUrl) 
const iswww= regex.test(currentUrl) 
// let  api = process.env.NODE_ENV == 'development' ? '/devapi' : 'http://140.179.61.9:8066/csi'//new-测试
let  api = process.env.NODE_ENV == 'development' ? '/devapi' : 'https://www.csibizsearch.com/csi'//生产
// let api = process.env.NODE_ENV == 'development' ? '/devapi' :iswww?'https://www.csibizsearch.com/prod-api': 'https://csibizsearch.com/prod-api' //生产

// Data Cleaning 1.上传数据清洗文件
export const dataCleaningUpload = params => {
  return axios.post(api + '/dataCleaning/upload', params,{ type: "upload" })
}
// Data Cleaning 2.获取清洗字段
export const findAllEnableFields = params => {
  return axios.get(api + '/dataCleaningFileDic/findAllEnableFields')
}
// Data Cleaning 3.保存清洗字段并开始清洗
export const saveFiledsAndCleaning = params => {
  return axios.post(api + '/dataCleaningChoice/saveFiledsAndCleaning', params)
}
// Data Cleaning 3.1清洗进度轮询
export const getUploadProgress = params => {
  // return axios.get(api + '/dataCleaning/getUploadProgress'+ params)
  return axios({
    isLoading: true,//配置这个，全局的loading就不显示
    url: api + '/dataCleaning/getUploadProgress',
    method: 'GET',
    params
  })
}
// Data Cleaning 4.查询已上传文件、状态等概要
export const getFilesList = params => {
  return axios({
    isLoading: true,
    url: api + '/dataCleaningFile/getFilesList',
    method: 'GET',
    params
  })
}
// Data Cleaning 5.查询已上传文件成功率
export const getStatistics = params => {
  return axios.get(api + '/dataCleaningFile/getStatistics')
}
// Data Cleaning 6.查询已上传的公司清洗明细
export const getUploadedCompanies = params => {
  return axios.post(api + '/dataCleaning/getUploadedCompanies', params)
}
// Data Cleaning 6.1聚合明细结果
export const getUploadedCompaniesAgg = params => {
  return axios({
    isLoading: true,
    url: api + '/dataCleaning/getUploadedCompaniesAgg',
    method: 'GET',
    params
  })
}
// Data Cleaning 7.重新生成
export const regenerate = params => {
  return axios.post(api + '/dataCleaning/regenerate', params)
}
// Data Cleaning 获取用户已选择过的字段
export const findListByBatchIdAndUserId = params => {
  return axios.get(api + '/dataCleaningChoice/findListByBatchIdAndUserId' + params)
}
// Data Cleaning 子数据 Update
export const getMenuList = params => {
  return axios.get(api + '/companyExport/getMenuListForComplete')
}

// Data Cleaning 添加标签
export const insertEnum = params => {
  return axios.post(api + '/dataCleaningFile/insertEnum', params)
}

// Data Cleaning 更新标签
export const updateEnum = params => {
  return axios.post(api + '/dataCleaningFile/updateEnum', params)
}

// Data Cleaning 删除标签
export const deleteEnum = params => {
  return axios.post(api + '/dataCleaningFile/deleteEnum', params)
}

// Data Cleaning 聚合标签下拉
export const getAllEnum = params => {
  return axios.get(api + '/dataCleaningFile/getAllEnum')
}
// Data Cleaning 获取成功失败明细-生成excel用
export const getUploadedCompaniesResult = params => {
  return axios.get(api + '/dataCleaning/getUploadedCompaniesResult' + params)
}

// Data Cleaning Download
export const downloadFileByFileId = params =>  {
  return axios({
    url: api + '/dataCleaning/downloadFileByFileId',
    method: 'POST',
    responseType: 'blob', 
    data:params
  })
}
// Data Cleaning 子数据 Download
export const downloadFileByIds = params => {
  return axios({
    url: api + '/dataCleaning/downloadFileByIds',
    method: 'POST',
    responseType: 'blob', 
    data:params
  })
}

// Data Cleaning 子数据 Match-Online Matching
export const matchUploadDataCleaning = params => {
  return axios.post(api + '/dataCleaning/matchUploadDataCleaning', params)
}

// Data Cleaning 子数据 Match-Offline Matching
export const insertOfflineMatchingEntity = params => {
  return axios.post(api + '/dataCleaning/insertOfflineMatchingEntity', params)
}

// Data Cleaning 子数据单个 Clean-弹框-Download
export const exportExcelData = params => {
  return axios.post(api + "/companyExport/exportExcelDataForComplete", params, {
    type: "download",
  });
}

// Data Cleaning 子数据多选 Clean-弹框-Download
export const exportMultiExcelDataForComplete = params => {
  return axios.post(api + '/companyExport/exportMultiExcelDataForComplete', params, {
    type: "download",
  })
}

// Data Cleaning 子数据 Clean-弹框-Update
export const addMultiUpdateTask = params => {
  return axios.post(api + '/dataCleaning/addMultiUpdateTask', params)
}

// Data Cleaning 子数据 Clean-弹框-Update-模块价格计算
export const calculatePrice = params => {
  return axios.post(api + '/dataCleaningModulePrice/calculatePrice', params)
}

// Bulk Data 获取DataRange模块数据
export const getDataRange = params => {
  return axios.get(api + '/bulkData/getDataRange')
}

// Bulk Data 获取树形结构DataDimension
export const getDimenSion = params => {
  return axios.get(api + '/bulkData/getDimenSion')
}

// Bulk Data 提交任务
export const addTask = params => {
  return axios.post(api + '/bulkData/addTask', params)
}

// Bulk Data 分页+查询
export const queryTask = params => {
  return axios.post(api + '/bulkData/queryTask', params)
}

// Bulk Data 下载并更新点击次数
export const downloadFileByIdBD = params =>  {
  return axios.get(api + '/bulkData/downloadFileById' + params)
}

// Data api 获取api列表
export const getApiDataCategory = params => {
  // return axios.post(api + '/apiData/getApiDataCategory', params)
  return axios({
    isLoading: true,
    url: api + '/apiData/getApiDataCategory',
    method: 'POST',
    data:params
  })
}
// Data api 获取api列表-二级分类数据
export const getApiDataApiPage = params => {
  return axios.post(api + '/apiData/getApiDataApiPage', params)
}
// Data api 获取api列表-二级分类的详情数据
export const getApiDataApiItemById = params => {
  return axios.get(api + '/apiData/getApiDataApiItemById' + params)
}
// Data api 获取账号信息
export const generateAppKeyInfo = () => {
  return axios.get(api + '/apiDataAccount/generateAppKeyInfo')
}
// Data api 确认申请账号
export const applyAccount = params =>  {
  return axios({
    isLoading: true,
    url: api + '/apiDataAccount/applyAccount',
    method: 'POST',
    data:params
  })
}
// Data api 查询账号-筛选和分页
export const getAccountsPage = params =>  {
  return axios({
    url: api + '/apiDataAccount/getAccountsPage',
    method: 'POST',
    data:params
  })
}
// Data api 下载文档
export const downLoadFileByItemId = params =>  {
  return axios({
    url: api + '/apiData/downLoadFileByItemId',
    method: 'POST',
    data:params
  })
}
// Data api 删除账号
export const deleteAccount = params =>  {
  return axios({
    url: api + '/apiDataAccount/deleteAccount',
    method: 'DELETE',
    params
  })
}
// Data api 续次数
export const renewalCount = params =>  {
  return axios({
    url: api + '/apiDataAccount/renewalCount',
    method: 'GET',
    params
  })
}
// Data api 续时间
export const renewalExpireTime = params =>  {
  return axios({
    url: api + '/apiDataAccount/renewalExpireTime',
    method: 'GET',
    params
  })
}
// Data api 聚合下拉
export const getFilterList = params =>  {
  return axios({
    url: api + '/apiDataAccount/getFilterList',
    method: 'GET',
    params
  })
}
// Data api 调用接口测试
export const apiDataCall = params =>  {
  return axios({
    url: api + '/apiDataCall/apiDataCall',
    method: 'POST',
    data:params
  })
}
// Data api 日志查询
export const apiDataCallQueryPage = params =>  {
  return axios({
    url: api + '/apiDataCall/apiDataCallQueryPage',
    method: 'POST',
    data:params
  })
}
// Data api 批量下载  一级api
export const downloadPatchCategory = params =>  {
  return axios({
    url: api + '/apiData/downloadPatchCategory',
    method: 'POST',
    responseType: 'blob', 
    data:params
  })
}
// Data api 批量下载  二级api
export const downloadPatchApi = params =>  {
  return axios({
    url: api + '/apiData/downloadPatchApi',
    method: 'POST',
    responseType: 'blob', 
    data:params
  })
}
// 首页搜索框 头部搜索框 下拉数据
export const getApiCatalogueTree = params => {
  return axios.get(api + '/apiData/getApiCatalogueTree')
}
// Customize Your Own Plan 获取问卷问题和答案合集
export const getCustomizePlanQA = params => {
  return axios.get(api + '/customizePlan/getCustomizePlanQA')
}

// Customize Your Own Plan 获取推荐结果(问卷结果)
export const getCustomizeScore = params =>  {
  return axios({
    url: api + '/customizePlan/getCustomizeScore',
    method: 'POST',
    data:params
  })
}